export default "__VITE_ASSET__C0mz_btx__"